<template>
  <div class="box">
    <div class="box-header">
      <h3 class="box-title">Product and Service</h3>
    </div>
    <div class="grids is-4-desktop gap-20-desktop">
      <div class="grid" v-for="(i, indx)  in productService" :key="indx">
        <i class="fa-solid fa-trash" @click="productService.splice(indx, 1)"></i>
        <div class="grid-info">
          <input type="text" class="input" v-model="productService[indx].title" placeholder="Name" />
          <textarea name="" id="" rows="3" v-model="productService[indx].detail" class="textarea"></textarea>
        </div>
      </div>
      <div class="add" v-if="productService.length < 100" @click="isProductServices()"><i class="fa-light fa-plus"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['productServices'],
  data: () => ({
    productService: []
  }),
  watch: {
    productService: {
      handler(val) {
        this.$emit("input", val)
      },
      immediate: true,
      deep: true
    },
    productServices: {
      handler(val) {
        if (val) {
          const info = val.map((i) => {
            return {
              title: i.title,
              detail: i.detail
            }
          })
          this.productService = info
        }
      },
      immediate: true
    }
  },
  methods: {
    isProductServices() {
      this.productService.push({
        title: "",
        detail: ""
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.add {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  cursor: pointer;
  background-color: rgba(var(--primary-color-rgb), 0.05);
  border: 1px solid var(--primary-color);

  i {
    color: var(--primary-color);
    font-size: var(--xxlg-font);
  }
}
</style>
